// The screen and server preserve the same facts on edit, save and send.
export type NoticeVisit = {date:string;amount_pence:number|null;reason:string}
export function noticeFacts(old:number,next:number,date:string,protectedVisits:NoticeVisit[],currency:string):string[] {
  const money=(p:number)=>new Intl.NumberFormat('en-GB',{style:'currency',currency}).format(p/100)
  const when=(day:string)=>new Date(`${day}T12:00:00Z`).toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'})
  return [
    `Your booked cleans from ${when(date)} will be ${money(next)}. Cleans before ${when(date)} stay at ${money(old)}.`,
    'This applies to the usual outside clean. Insides and extras keep their current amounts. First cleans, cleans done in parts or carried over, visits on an invoice and cleans with a different outside price keep their own prices.',
    protectedVisits.length ? `These booked visits currently keep their own prices:\n${protectedVisits.map(v=>`${when(v.date)}: ${v.amount_pence==null?'price not set':money(v.amount_pence)} (${String(v.reason).toLowerCase()})`).join('\n')}` : 'There are currently no booked visits keeping a different price.',
    'If you’d rather stop, just reply.',
  ]
}

export function noticeProblem(value:unknown,facts:string[]):string|null {
  if(typeof value!=='string'||value.length>12000)return 'Write a notice of up to 12,000 characters'
  const normal=(v:string)=>v.toLowerCase().replace(/[’‘]/g,"'").replace(/\s+/g,' ').trim()
  const words=normal(value)
  if(!facts[0]||!facts[3]||!words.includes(normal(facts[0]))||!words.includes(normal(facts[3])))return 'Keep the prices, the start date and how to stop'
  if(!facts.slice(1,3).every(f=>words.includes(normal(f))))return 'Keep which booked visits change and which keep their own prices'
  return null
}
